// Customise_Flag — decides whether the Bookflow_Links (utility links and
// shortlist hearts) are shown in the Bookflow header. They ship `hidden` in the
// built HTML, so any failure here leaves them hidden (Req 1.8).

const FLAG_PARAM = 'customise';
const FLAG_VALUE = 'true';
const BOOKFLOW_LINKS_SELECTOR = '[data-bookflow-links]';

/** Req 1.10: exactly 'true'. Never throws: a malformed search string reads as false. */
export function isCustomise(search: string): boolean {
  try {
    return new URLSearchParams(search).get(FLAG_PARAM) === FLAG_VALUE;
  } catch {
    return false;
  }
}

/** Un-hides every [data-bookflow-links] under headerEl. Returns whether it revealed. */
export function applyBookflowVisibility(headerEl: HTMLElement, search: string): boolean {
  if (!isCustomise(search)) return false;

  const links = headerEl.querySelectorAll<HTMLElement>(BOOKFLOW_LINKS_SELECTOR);
  links.forEach((el) => {
    el.hidden = false;
  });
  return links.length > 0;
}
